import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";

//store
import * as actions from "../../store/actions/actionIndex";

const Stopwatch = (props) => {
  let pausedTime = parseInt(props.pausedTime) || 0;
  let lastActivityTime = parseInt(props.lastActivityTime) || 0;

  const [timer, setTimer] = useState(
    props.agentState === "READY" ? (lastActivityTime ? lastActivityTime : 0) : pausedTime
  );
  const increment = useRef(null);

  let aTArr = props.allowedTime.split(":");
  let allowedSeconds = parseInt(aTArr[0]) * 3600 + parseInt(aTArr[1]) * 60 + parseInt(aTArr[2]);
  let counter = allowedSeconds - pausedTime;
  counter = counter > 0 ? counter : 0;

  const handleStart = () => {
    if (increment.current) return; // Prevent multiple intervals
    increment.current = setInterval(() => {
      setTimer((prevTimer) => prevTimer + 1);
    }, 1000);
  };

  const handleReset = () => {
    clearInterval(increment.current);
    increment.current = null;
    setTimer(0);
  };

  const { agentState } = props;

  useEffect(() => {
    if (agentState === "BREAK" || agentState === "READY") {
      handleStart();
    } else {
      handleReset();
    }

    return () => handleReset(); 
  }, [agentState]);

  // Handle visibility change
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        let updatedLastActivityTime = parseInt(props.lastActivityTime) || 0;
        if (updatedLastActivityTime > timer) {
          setTimer(updatedLastActivityTime);
        }
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [props.lastActivityTime, timer]);

  const formatTime = () => {
    const getSeconds = `0${timer % 60}`.slice(-2);
    const minutes = `${Math.floor(timer / 60)}`;
    const getMinutes = `0${minutes % 60}`.slice(-2);
    const getHours = `0${Math.floor(timer / 3600)}`.slice(-2);

    return `${getHours} : ${getMinutes} : ${getSeconds}`;
  };

  if (!counter) {
    return <span style={{ color: "red" }}>{formatTime()}</span>;
  }

  return <span>{formatTime()}</span>;
};

const mapStateToProps = (state) => ({
  allowedTime: state.agentData.allowedTime,
  pausedTime: state.agentData.pausedTime,
  lastActivityTime: state.agentData.lastActivityTime,
  agentState: state.agentData.agentState,
  agentId: state.agentData.agentId,
});

const mapDispatchToProps = (dispatch) => ({
  onAgentBreak: (agentId, breakState, reason) => dispatch(actions.agentBreak(agentId, breakState, reason)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Stopwatch);
